export default __webpack_public_path__ + "8587719c84b68bfa16e93adcfa448b35.png";